import './LabelSelect.scss';

export default function LabelSelect({
  children,
  label,
  value = '',
  onChange,
  onBlur,
  name,
  error,
  disabled,
  className,
  placeholder,
  selectKey, // forces remount on iOS when options change
}) {
  return (
    <div className={'label-select' + (className ? ' ' + className : '')}>
      <label className={error ? 'error' : ''}>
        {error ? `${label}: ${error}` : label}
      </label>
      <select
        key={selectKey}
        value={value ?? ''}
        onChange={onChange}
        onBlur={onBlur}
        name={name}
        disabled={disabled}
      >
        {placeholder && (
          <option value='' disabled hidden>
            {placeholder}
          </option>
        )}
        {children}
      </select>
    </div>
  );
}
